export class SyncTimestampDto {
  timestamp: Date;
  archived: boolean;

  constructor(
    public _id: string,
    public latestTimestamp: Date,
    public initialSyncStart: Date
  ) {
    this.timestamp = new Date();
  }
}
